import React from "react";
import { URLs } from "../utils/apis";
import { useStylesNotification } from "../utils/mantine/useStylesNotification";
import { Box, Flex, Text, useMantineTheme } from "@mantine/core";
import CustomAnchor from "./mantineCustomComponents/CustomAnchor";

const Notification = () => {
  // Mantine theme instance to apply custom styles and theming throughout the component
  const theme = useMantineTheme();

  // css classes
  const { classes: notificationClasses } = useStylesNotification();
  return (
    <Box className={notificationClasses.notificationBlock}>
      <Box>
        <Text className={notificationClasses.notificationBlockText}>
          To start making stamps,{" "}
          <Text component="b">get your FREE vBase account!</Text>{" "}
        </Text>

        <Flex
          justify={theme.flex.justify.between}
          className={notificationClasses.notificationBlockButtons}
        >
          <CustomAnchor
            text="Register"
            href={URLs.ACCOUNTS_SIGNUP_URL}
            componentClasses={`${notificationClasses.notificationBlockButtonsItem} buttonWhite`}
          ></CustomAnchor>
          <CustomAnchor
            text="Sign In"
            href={URLs.ACCOUNTS_LOGIN_URL}
            componentClasses={`${notificationClasses.notificationBlockButtonsItem} buttonWhite`}
          ></CustomAnchor>
        </Flex>
      </Box>
    </Box>
  );
};

export default Notification;
